import React, { useState } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import {
  AppBar,
  Box,
  Toolbar,
  makeStyles,
  IconButton,
  Dialog,
} from "@material-ui/core";
import NotificationsIcon from "@material-ui/icons/Notifications";
import SwipeableTemporaryDrawer from "./RightDrawer";
import Logo from "src/component/Logo";
import DialogContent from "@material-ui/core/DialogContent";
import NotificationList from "src/views/pages/notifications/index";
import { FaQuestion } from "react-icons/fa";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
  },
  toolbar: {
    height: 70,
  },
  logo: {
    marginRight: theme.spacing(2),
  },
  link: {
    fontWeight: theme.typography.fontWeightMedium,
    "& + &": {
      marginLeft: theme.spacing(2),
    },
  },
  divider: {
    width: 1,
    height: 32,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  desktopDrawer: {
    position: "absolute",
    right: 80,
    top: 30,
    width: 450,
    // background: theme.palette.primary.main,
    height: 450,
    [theme.breakpoints.down("sm")]: {
      width: 300,
      right: 0,
    },
  },
}));

const TopBar = ({ className, onMobileNavOpen, ...rest }) => {
  const classes = useStyles();

  return (
    <AppBar className={clsx(classes.root, className)} color="default" {...rest}>
      <Toolbar className={classes.toolbar}>
        <TopBarData />
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
};
TopBar.defaultProps = {
  onMobileNavOpen: () => {},
};

export default TopBar;

export function TopBarData() {
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = useState(false);
  return (
    <>
      <Logo
        width="180"
        style={{
          paddingTop: "0px",
          fontSize: "30px",
          color: "#20dcb6",
          paddingLeft: "15px",
          cursor: "pointer",
        }}
      />
      <Box flexGrow={1} />
      <IconButton style={{ marginRight: 5 }} onClick={() => setOpen(true)}>
        <NotificationsIcon style={{ color: "#707070" }} />
      </IconButton>
      <IconButton
        style={{ marginRight: 10, border: "1px solid #00e0b0" }}
        onClick={() => history.push("/faq")}
      >
        <FaQuestion size={18} style={{ color: "#707070" }} />
      </IconButton>
      <SwipeableTemporaryDrawer />

      <Dialog
        classes={{ paper: classes.desktopDrawer }}
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
          <NotificationList popUp={open} />
        </DialogContent>
      </Dialog>
    </>
  );
}
